<div
    #containerMessage
    class="flex flex-col relative overflow-hidden kiwid-socket-connection"
    [class.h-[calc(var(--kiwid-vh-content)-57px)]]="!isMobile()"
    [class.h-[calc(var(--kiwid-vh-100)-54px)]]="isMobile()"
>
    <div
        class="flex flex-col relative bg-kiwid-bg-page border-[2px] dropzone"
        appUploadDrop
        (files)="filesDropped($event)"
        hoverBorderColor="#158fef"
        hoverBackgroundColor="#DBE1E5FF"
    >
        <div class="drop-placeholder">
            <mat-icon svgIcon="feather:upload-cloud" class="mr-2 text-white size-20" />
            {{ 'ORDER_CLINIC_MESSAGE.DROPZONE.DESCRIPTION' | translate }}
        </div>

        <app-list-clinic-message
            [style.height]="containerMessage.clientHeight - containerFooter.clientHeight + 'px'"
            [orderDataSelected]="orderDataSelected()"
            (emitFirstPage)="refKInputMessage()?.focus()"
        >
            <div class="p-7 m-auto flex flex-col gap-[26px] justify-center items-center z-10">
                <k-empty
                    class="m-auto"
                    [size]="130"
                    customPaddingBottom="13px"
                    imageUrl="assets/images/chat/placeholder-empty.svg"
                    [description]="'ORDER_CLINIC_MESSAGE.EMPTY' | translate"
                />
            </div>
        </app-list-clinic-message>
    </div>

    <div #containerFooter class="bg-kiwid-surface flex items-end min-h-[68px] py-4 px-5 gap-3" style="z-index: 1">
        @if (viewFooter().enabled) {
            <ngx-avatars [src]="viewFooter().avatarUrl" [name]="viewFooter().name" [size]="32" [initialsSize]="2" />

            <k-input-message #kInputMessage [placeholder]="viewFooter().placeholder" (submit)="sendMessage()" [formControl]="formControlMessage()" />

            <div class="gap-2 flex items-center min-h-[34px]">
                @if (viewFooter().enableSend()) {
                    <mat-icon class="size-24 text-neutral-lighter hover:cursor-pointer" (click)="sendMessage()"> send </mat-icon>
                }
                @if (viewFooter().enableFile()) {
                    <mat-icon
                        class="size-24 text-neutral-lighter hover:cursor-pointer"
                        [matMenuTriggerFor]="matMenuFile"
                        svgIcon="kiwid:attach-file"
                    />
                }
            </div>
        } @else {
            <span class="text-neutral-default text-[15px] font-semiBold m-auto">
                {{ viewFooter().disabledMessage }}
            </span>
        }
    </div>
</div>

<mat-menu #matMenuFile="matMenu" class="top arrow-right fab-button" yPosition="above">
    <label for="files" mat-menu-item>
        <mat-icon class="mr-2">insert_drive_file</mat-icon>
        {{ 'ORDER_CLINIC_MESSAGE.MAT_MENU.FILES' | translate }}
        <input #fileInput style="display: none" type="file" id="files" name="files" multiple (change)="uploadRaw(fileInput)" />
    </label>

    <label for="photo-video" mat-menu-item>
        <mat-icon class="mr-2">add_a_photo</mat-icon>

        {{ 'ORDER_CLINIC_MESSAGE.MAT_MENU.PHOTOS_AND_VIDEOS' | translate }}

        <input
            #imageInput
            style="display: none"
            accept="image/*,video/*,audio/*"
            type="file"
            id="photo-video"
            name="photo-video"
            multiple
            (change)="uploadImageOrVideos(imageInput)"
        />
    </label>
</mat-menu>
